import React from 'react';
interface FormStepProps {
  title: string;
  description?: string;
  isActive: boolean;
  children: React.ReactNode;
}
export const FormStep: React.FC<FormStepProps> = ({
  title,
  description,
  isActive,
  children
}) => {
  if (!isActive) return null;
  return <div className="p-8 md:p-10" data-id="element-756">
      <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-757">
        {title}
      </h2>
      {description && <p className="text-white/90 mb-8" data-id="element-758">{description}</p>}
      {children}
    </div>;
};